import React from "react";
import Copy from "../components/sections/Copy";
import EmployeeCard from "../components/modules/EmployeeCard";
import FullWidthImage from "../components/sections/FullWidthImage";
import Hero from "../components/sections/Hero";
import LeftImageText from "../components/sections/LeftImageText";
import RightImageText from "../components/sections/RightImageText";
import ImageCard from "../components/modules/ImageCard";
import ImageText from "../components/modules/ImageText";
import CollectionProductsList from "../components/static/collection-products";
import KeyBenefitsSection from "../components/sections/KeyBenefits";
import HowItWorksBlock from "../components/sections/HowItWorks";
import BlockifiedModel from "../components/sections/BlockifiedModel";
import HubspotForm from "../components/sections/HubspotForm";
import FeaturedProduct from "../components/products/featuredProduct";
import CallToAction from "../components/elements/CtaButton";
import Video from "../components/modules/Video";
import BlogPost from "../components/modules/BlogPost";
import EmployeeCardWrap from "../components/modules/EmployeeCardWrap";

// for some certain kinds of blocks (mostly inline-displayed elements), we may need to build in a wrapper
// to allow easier control over groups of them -- this wrapper will start when the first block of the type
// is encountered and wrap all subsequent instances of the same block type
export const getWrapperFromBlockType = (blockType) => {
  const wrappers = {
    EmployeeCard: EmployeeCardWrap,
  };

  const wrapper = wrappers[blockType.split("DatoCms")[1]];
  return wrapper;
};

export const getComponentFromBlockType = (blockType) => {
  const components = {
    Copy,
    FullWidthImage,
    Hero,
    LeftImageText,
    RightImageText,
    EmployeeCard,
    ImageCard,
    CollectionProductsList,
    KeyBenefitsSection,
    HowItWorksBlock,
    BlockifiedModel,
    FeaturedProduct,
    CallToAction,
    Video,
    BlogPost,
    HubspotForm,
    ImageText,
  };

  /* componentToRender:  this is us trimming the graphql field group name so
    that we can dynamically render components in any order the might come down.
    as an example `post_Postsectiongroup_Postsections_Storycard` .. we
    trim off Storycard so that we can use this to reference the key off 
    the components object defined at the top of the component definition.

    we then pass the object itself to the component in the "data" prop to use
    in the component for state & templating
    */

  const componentToRender = components[blockType.split("DatoCms")[1]];
  return componentToRender;
};

export const renderGenericPageContent = (
  pageContent,
  customClass,
  useWrappers = true
) => {
  const getContentIterator = () => {
    var i = 0;
    return {
      next: () => {
        let contentBlock = pageContent[i];
        i++;
        return contentBlock;
      },
      getIndex: () => {
        return i;
      },
    };
  };
  const iter = getContentIterator();
  var content = [];
  var item = iter.next();
  // item is undefined when we've gone through all the content -- if "undefined" is a valid value that can come from pageContent,
  // we can make the iterator throw an error once its out of content to give and then catch that appropriately out here
  while (item) {
    const blockType = item.internal.type;
    const Component = getComponentFromBlockType(blockType);
    if (!Component) {
      return <></>;
    }
    // get the block's wrapper if it has one associated
    const Wrapper = getWrapperFromBlockType(blockType);
    if (Wrapper && useWrappers) {
      // if it does have a wrapper associated, lets bundle up all the components of the same type and render all of theme within the wrapper
      let allComponentsOfType = [item];
      while (
        (item = iter.next()) &&
        item.internal &&
        item.internal.type === blockType
      ) {
        allComponentsOfType.push(item);
      }
      // we can use this recursively as long as we flag not to keep wrapping the elements -- there should never need be a case of recursive
      // wrapping unless something changes signficantly in the way we structure the components from Dato
      content.push(
        <Wrapper>
          {renderGenericPageContent(allComponentsOfType, customClass, false)}
        </Wrapper>
      );
      // we can simply continue here, knowing that "item" has been updated to be the next element of a different type already
      continue;
    }
    const key = iter.getIndex();
    content.push(
      <Component
        key={key}
        customClass={customClass}
        data={item}
        field={blockType}
      />
    );
    item = iter.next();
  }
  return content;
};

export const renderContent = (content) => {
  return { __html: content };
};
